module.exports = __webpack_public_path__ + "static/media/ex1_3_4-slow.6d37e8ab.mp3";